import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import * as ReportingRead from '../../Apis/ReportingReadApi';
import * as Actions from './AdminWebinarsActions';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';

export function* getAdminWebinarsWatcher() {
  yield takeLatest(Actions.GET_ADMIN_WEBINARS_REQUEST, getAdminWebinarsWorker);
}

export function* getWebinarCreatorsWatcher() {
  yield takeLatest(Actions.GET_WEBINAR_CREATORS_REQUEST, getWebinarCreatorsWorker);
}

export function* getAdminWebinarsWorker(action) {
  try {
    let webinarsList = [];
    const { fromTime, toTime, limit, accountKey, page, filter, creators } = action.payload;
    const staffKeys = creators.map(creator => creator.staffKey).toString();
    const axiosResponse = yield call(
      ReportingRead.getAdminWebinars,
      accountKey,
      fromTime,
      toTime,
      page,
      limit,
      filter,
      staffKeys
    );
    const apiBody = axiosResponse.data;
    const { data, ...pagination } = apiBody;
    webinarsList = [...webinarsList, ...data];
    pagination.pageCount = Math.ceil(pagination.total / pagination.limit);
    yield put({
      type: Actions.GET_ADMIN_WEBINARS_SUCCESS,
      payload: { webinarsList, pagination, creators }
    });
  } catch (error) {
    yield put({ type: Actions.GET_ADMIN_WEBINARS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export function* getWebinarCreatorsWorker(action) {
  try {
    let creators = [];
    const { accountKey, fromTime, toTime, page, filter, limit } = action.payload;
    const axiosResponse = yield call(
      ReportingRead.getWebinarCreators,
      accountKey,
      fromTime,
      toTime,
      page,
      filter,
      limit
    );
    const apiBody = axiosResponse.data;
    const { data, ...pagination } = apiBody;
    creators = [...creators, ...data];
    yield put({
      type: Actions.GET_WEBINAR_CREATORS_SUCCESS,
      payload: { creators, filter, page, nextPage: pagination.next }
    });
  } catch (error) {
    yield put({ type: Actions.GET_WEBINAR_CREATORS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getAdminWebinarsWatcher), fork(getWebinarCreatorsWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/AdminWebinars/AdminWebinarsSagas.js